module.exports = __webpack_public_path__ + "static/media/leopard-thing.d0956a50.jpg";